export const IPOColors = {
	blue: {
		primaryColor: '#0052CC', // 主色调
		primaryHoverColor: '#0065FF', // 选中颜色
		PrimaryDisabledColor: '#CBDCF5',
		navColor: '#0747A7', // 导航
		secondBlueColor: '#2684FF',
	},
	// 系统色

	ipoGreen: '#00875A', // 绿色
	ipoRed: '#DE350A', // 红色
	ipoWhite: '#FFF', // 白色
	ipoTransparent: 'transparent', // 红色

	text: {
		textImportant: '#172B4D',
		textInferior: '#344563',
		textSlight: '#6C788C', // 三级文字信息
		textNote: '#A9ADBA', // 用于辅助， 次要的文字信息
	},

	line: {
		lineImportant: '#CCCCCC',
		lineInferior: '#DFE1E6',
		lineSlight: '#EBECF0',
	},

	btn: {
		btnDefaultColor: '#F4F5F7', // 默认按钮
		btnDefaultHoverColor: '#EBECF0',
		btnInferiorColor: '#FAFBFC', // 次要按钮
		btnInferiorHoverColor: '#F4F5F7',
		btnDangerColor: '#F85151',
		btnGhostColor: '#FFFFFF',
	},

	borderGrey: '#DFE1E6',

	input: {
		inputBg: '#FAFBFC', // 输入框
		inputFocusBg: '#EBECF0',
	},
};

export const zLevel = {
	top1: 99999, // 系统最高层。 如消息通知， 通知栏信息
	top2: 9999, // 如请求成功，失败
	top3: 1054, //弹窗里的弹窗
	top4: 1001, //比modal高一层级
	top5: 999,
	top6: 99,
	top7: 9, // 临时需要高层
	top8: 1, // 显示高一层
	top9: -1, // 不显示
};
